import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import fetch from '../hooks/fetch';
import { fetchDataModelReports } from '../actions';
import DataModelReportsTable from '../components/DataModelReportsTable';

const DataModelReportsPanel = ({
  category,
  code,
  fetchData,
  readStatus,
  readErrors,
  reports,
}) => {
  fetch.useFetchDatasetReports(fetchData, category, code, readStatus);
  return (
    <DataModelReportsTable
      category={category}
      code={code}
      readStatus={readStatus}
      readErrors={readErrors}
      reports={reports}
    />
  );
};

const mapStateToProps = ({
  datasetReports: { dataModelReports },
}, {
  category, code,
}) => {
  const item = findResult(dataModelReports, category, code);

  return {
    readStatus: item?.readStatus || states.NONE,
    readErrors: item?.readErrors || [],
    reports: item?.items || [],
  };
};

const mapDispatchToProps = {
  fetchData: fetchDataModelReports,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataModelReportsPanel);
